import { CROP_TYPE } from "../crop.types";
import { UmbracoImageCrop } from "../models/media.interface";

export default (crops: UmbracoImageCrop[] | undefined, preferredCropAlias?: string, cropFallback?: CROP_TYPE): UmbracoImageCrop | undefined => {
    let imageCrop = undefined;

    if (crops && crops.length > 0) {
        imageCrop = crops.find((crop) => {
            if (preferredCropAlias) {
                const normalizedPreferredAlias = preferredCropAlias.split(" ")[0].toLowerCase();
                const normalizedCropAlias = typeof crop.alias === "string" ? crop.alias.split(" ")[0].toLowerCase() : "";
                return normalizedCropAlias === normalizedPreferredAlias;
            } else if (cropFallback) {
                return crop.alias === cropFallback.split(" ")[0].toLowerCase();
            } else {
                return crop.alias === "fullscreen";
            }
        });
    }

    return imageCrop;
};
